import React, { forwardRef ,useEffect} from 'react';
import { Box, Grid, Paper, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { StyledTableCellPrint, StyledTableRow } from '../../reusableComponent/Reusables';
import logo from '../../../images/logo-s.png';
import qa_image from '../../../images/logo-s.png';
import qoiImg from '../../../images/print_header.png';
import styles from '.././../../styles.module.css';
const ProductionPlanningPrint = forwardRef(({ printDetails }, ref) => {

    const printData = printDetails;
    console.log('printDetails:', printDetails);
    //const childRows = printDetails.schedule_details || [];
    const childRows = Array.isArray(printDetails.schedule_details) ? printDetails.schedule_details : [];
    console.log(childRows)
    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };

    return (
        <>

            <Box className="print-source" style={{ margin: '30px' }}  >
                <Paper sx={{ margin: '55px 15px 30px 15px', boxShadow: 'none', height: '90vh', backgroundColor: '#ffffff' }}>
                    <Grid container sx={{}}>
                        <Grid item xs={12} style={{
                            backgroundImage: `url(${qoiImg})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '60px',
                            marginBottom: '8px'
                        }}>
                            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                                <Typography sx={{ textAlign: 'start', marginLeft: '50px', marginTop: '10px', fontSize: '26px', fontWeight: 'bold', padding: '1px', color: '#ffffff' }}>
                                    SALES ORDER
                                </Typography>
                                <img src={logo} style={{ width: 'auto', height: '50px', marginTop: '5px', borderRadius: '2px', border: '2px solid #e10a0a' }} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} >
                            <Grid container>
                                <Grid item xs={8} >
                                    <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                                        CYLINDER TRACKING SYSTEM (I) Pvt. Ltd.
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        Gat No. 333, xyz xyz, Tal. xyz xyz, xyz - 400 008.
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        Email - demotes1234@gmail.com
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        Website - www.xyz.com / www.xyz.in
                                    </Typography>
                                </Grid>
                                {/* <Grid item xs={4} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                }}>
                                    <img src={qa_image} style={{ width: 'auto', height: '60px', borderRadius: '4px' }} />
                                </Grid> */}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', marginTop: '8px' }}>

                        </Grid>
                    </Grid>
                    <Grid container sx={{}}>
                        <Grid item xs={7} >
                            <Box sx={{ minHeight: '100px', margin: '6px', marginLeft: '0px', textAlign: 'left', }}>
                                <Typography sx={{ fontSize: '18px', fontWeight: 'bold', }}>
                                    {printData.customer_name}
                                </Typography>
                                <Typography sx={{ fontSize: '12px', }}>
                                    {printData.customer_address}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={5}>
                            <Grid container >
                                <Grid item xs={7} >
                                    <Box sx={{ minHeight: '100px', margin: '6px', marginRight: '0px', textAlign: 'right' }}>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            SO No
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            SO Date
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            Issued By
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            Approved By
                                        </Typography>
                                    </Box >
                                </Grid>
                                <Grid item xs={0.5} >
                                    <Box sx={{ textAlign: 'center', margin: '6px', }}>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={4.5} sx={{ textAlign: 'right' }}>
                                    <Box sx={{ margin: '6px' }}>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.so_no}</Typography>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {dateConversion(printData.so_date)}</Typography>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.issued_by}</Typography>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.delivery_by}</Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} >

                        </Grid>
                    </Grid>
                    <Box style={{ height: '20px' }}> </Box>
                    <>
                        <TableContainer sx={{
                            minWidth: 650,
                            minHeight: 280,
                            padding: '0px 1px 0px 1px'
                        }}>
                            <Table size="small" style={{ borderCollapse: 'collapse' }}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCellPrint align="center" className={`${styles.print_table_head}`}>Product Code</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Cylinder Code </StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Cylinder Holding</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Current Holding</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Max Allowable Cylinder Delivery</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Cylinder Delivery No</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >UOM</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Quantity </StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Po Quantity</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Delivery Quantity</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Balance Quantity</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Unit Rate</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right" className={`${styles.print_table_head}`} >Amount</StyledTableCellPrint>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(childRows && childRows).map((row) => (
                                        <StyledTableRow>
                                            <StyledTableCellPrint align="center" className={`${styles.print_table_body}`}>{row.product_code}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.cylinder_code}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.cylinder_holding}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.current_holding}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.max_allowable_cylinder_delivery}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.no_cylinder_delivery}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.uom}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.quantity}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.po_quantity}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.delivered_quantity}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.balance_quantity}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.unit_rate}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="right" className={`${styles.print_table_body}`}>{row.amount}</StyledTableCellPrint>
                                        </StyledTableRow >
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                    <br />
                    <>
                        <Box style={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', }}>
                        </Box>
                        <Box sx={{ textAlign: 'left' }}>
                            <Grid container >
                                <Grid item xs={8} sx={{ minHeight: '130px' }}>
                                    <Box sx={{ textAlign: 'left', padding: '4px 4px 4px 0px' }}>
                                        <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                            Terms & Conditions*
                                        </Typography>

                                    </Box>
                                </Grid>
                                <Grid item xs={4} >
                                </Grid>
                            </Grid>
                        </Box>
                        <Grid container >
                            <Grid item xs={12} >
                                <Box sx={{ padding: '4px 14px 4px 4px', }}>

                                    <Typography sx={{ textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
                                        For <span style={{ fontWeight: 'bold' }}> CYLINDER TRACKING SYSTEM (I) Pvt Ltd</span>
                                    </Typography>
                                    <Typography sx={{ textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
                                        XYZ XYZ XYZ (11234567890)
                                    </Typography>
                                    <br />
                                    <br />
                                    <Typography sx={{ color: '#000000', textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
                                        Authorized Signatory
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </>
                </Paper>

            </Box >
        </>
    );
});

export default ProductionPlanningPrint;
